<template>
    <div class="review-sign">
        <h2>Review &amp; Sign</h2>
        <p class="review-sign-note">Save your changes on each tab before signing.</p>
        <div class="review-attestation">
            <p>By electronically signing this attestation, you are confirming that:</p>
            <ul>
                <li>You have reviewed the medical questions and answers submitted on your behalf.</li>
                <li>The information is true, complete, and accurate to the best of your knowledge.</li>
                <li>No known medical condition, diagnosis, treatment, medication, procedure, test, or other requested medical information has been intentionally omitted or misrepresented.</li>
                <li>You understand that the underwriting decision will rely upon the information contained in your application.</li>
                <li>If any answer is incorrect or incomplete, you will not sign the attestation until the information has been corrected.</li>
            </ul>
            <div class="review-sign-consent">
                <input type="checkbox" id="review-confirm" v-model="isConfirmed">
                <label for="review-confirm">
                    By signing below, you confirm that you have personally reviewed and approved the medical information submitted with your application.
                </label>
            </div>
        </div>
        <div class="signature">
            <p>
                <b>Signature (Required): </b>
                <span>(Sign your name using your mouse or touch screen in the box below)</span>
            </p>
            <signature-pad ref="signpad" @sign="onSign"></signature-pad>
        </div>
        <div class="text-center mt-4">
            <button type="button" class="submitSignature" :disabled="!canSubmit" @click="submit">
                <b-spinner v-if="isSubmitting" small></b-spinner>
                Submit
            </button>
        </div>
    </div>
</template>

<script>
import SignaturePad from '@/components/SignaturePad';
import reviewApi from '@/resource/memberReviewApi';
import { notify, notifyError } from '@/resource/memberReviewNotify';

export default {
    name: 'ReviewAndSign',
    components: {
        SignaturePad,
    },
    data: () => ({
        isConfirmed: false,
        sign: '',
        signHash: (Math.random() + 1).toString(36).substring(7),
        isSubmitting: false,
    }),
    computed: {
        canSubmit() {
            return this.isConfirmed && !!this.sign && !this.isSubmitting;
        },
    },
    methods: {
        onSign(data) {
            this.sign = data || '';
        },
        async submit() {
            if (!this.canSubmit) return;
            this.isSubmitting = true;
            try {
                const res = await reviewApi.submit({ sign: this.sign, sign_hash: this.signHash });
                notify(this, 'success', res.data.message);
                this.$emit('submitted');
            } catch (err) {
                if (err && err.response && err.response.status === 409) {
                    this.$emit('submitted');
                    return;
                }
                notifyError(this, err);
            } finally {
                this.isSubmitting = false;
            }
        },
    },
};
</script>
